import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import {
  primary,
  secondary,
  error,
  grey,
  grey_dark,
  text__primary
} from '../../../style';

export default withStyles(theme => ({
  root: {
    '&:hover': {
      cursor: 'pointer',
      textDecoration: 'underline',
      textDecorationColor: primary
    }
  }
}))(Typography);



// WEBPACK FOOTER //
// ./src/components/shared/components/LinkText.js